import { IExperimentResponsePayload, IExperimentStartPayload, IExperimentStatusPayload, IExperimentStatusResponse, IPrometheusApiResponse } from '../../models/SiteReliabilityModels';
import { IStoreAction } from '../StoreHelper';
import ISiteReliabilityState from '../state/SiteReliabilityState';

export enum SiteReliabilityActionTypes {
  TRIGGER_EXPERIMENT_START = 'TRIGGER_EXPERIMENT_START',
  TRIGGER_EXPERIMENT_SUCCESS = 'TRIGGER_EXPERIMENT_SUCCESS',
  TRIGGER_EXPERIMENT_ERROR = 'TRIGGER_EXPERIMENT_ERROR',

  EXPERIMENT_STATUS_START = 'EXPERIMENT_STATUS_START',
  EXPERIMENT_STATUS_SUCCESS = 'EXPERIMENT_STATUS_SUCCESS',
  EXPERIMENT_STATUS_ERROR = 'EXPERIMENT_STATUS_ERROR',

  PROMETHEUS_API_START = 'PROMETHEUS_API_START',
  PROMETHEUS_API_SUCCESS = 'PROMETHEUS_API_SUCCESS',
  PROMETHEUS_API_ERROR = 'PROMETHEUS_API_ERROR',

  GET_FINJ_STATUS_START = 'GET_FINJ_STATUS_START',
  GET_FINJ_STATUS_SUCCESS = 'GET_FINJ_STATUS_SUCCESS',
  GET_FINJ_STATUS_ERROR = 'GET_FINJ_STATUS_ERROR',
}

export type SiteReliabilityActionPayload = 
Error |
null |
undefined |
string |
ISiteReliabilityState |
IExperimentStatusPayload |
IExperimentStatusResponse |
IExperimentStartPayload |
IExperimentResponsePayload |
IPrometheusApiResponse;

export type SiteReliabilityAction = IStoreAction<SiteReliabilityActionTypes, SiteReliabilityActionPayload>;

export class SiteReliabilityActions {
  public static triggerExperimentStart(data: IExperimentStartPayload): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_START,
      data
    };
  }
  public static triggerExperimentSuccess(data: IExperimentResponsePayload): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_SUCCESS,
      data,
    };
  }
  public static triggerExperimentError(error: Error): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.TRIGGER_EXPERIMENT_ERROR,
      data: error,
    };
  }

  public static experimentStatusStart(data: IExperimentStatusPayload): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.EXPERIMENT_STATUS_START,
      data
    };
  }
  public static experimentStatusSuccess(data: IExperimentStatusResponse): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.EXPERIMENT_STATUS_SUCCESS,
      data,
    };
  }
  public static experimentStatusError(error: Error): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.EXPERIMENT_STATUS_ERROR,
      data: error,
    };
  }

  public static prometheusApiStart(): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.PROMETHEUS_API_START,
    };
  }
  public static prometheusApiSuccess(data: IPrometheusApiResponse): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.PROMETHEUS_API_SUCCESS,
      data,
    };
  }
  public static prometheusApiError(error: Error): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.PROMETHEUS_API_ERROR,
      data: error,
    };
  }

  public static getFisStatusStart(): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.GET_FINJ_STATUS_START,
    };
  }
  public static getFisStatusSuccess(data: string): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.GET_FINJ_STATUS_SUCCESS,
      data,
    };
  }
  public static getFisStatusError(error: Error): SiteReliabilityAction {
    return {
      type: SiteReliabilityActionTypes.GET_FINJ_STATUS_ERROR,
      data: error,
    };
  }
}
